<template>
  <v-container v-if="perguntas.length > 0 && this.payload">
    <v-breadcrumbs
      v-if="isSala"
      :items="breadCrumbs"
      divider=">"
    ></v-breadcrumbs>

    <h2 class="mb-5">Diagnóstico {{ municipio.nome }}/{{ municipio.uf }}</h2>

    <div v-if="isEnviada()" class="enviada">
      <v-icon color="#fff">mdi-alert-circle</v-icon> Esse diagnóstico já foi
      enviado para análise!
    </div>
    <v-form ref="form">
      <div v-for="(grupo, i) in perguntas" :key="i" class="grupo">
        <template
          v-if="aparecerAbaixoPerguntaCoringa(grupo.children[0].perguntaId)"
        >
          <div
            :class="`${grupo.status} bloco`"
            @click="
              () => {
                grupo.close = !grupo.close;
                $forceUpdate();
              }
            "
          >
            {{ grupo.name }}

            <div v-if="grupo.close" style="margin-left: auto">
              <v-icon color="#fff">mdi-arrow-down-drop-circle-outline </v-icon>
            </div>
            <div v-if="!grupo.close" style="margin-left: auto">
              <v-icon color="#fff">mdi-arrow-up-drop-circle-outline </v-icon>
            </div>
          </div>
          <template v-if="!grupo.close">
            <div
              v-for="(children, index) in grupo.children"
              :key="index"
              style="position: relative"
            >
              <template
                v-if="aparecerAbaixoPerguntaCoringa(children.perguntaId)"
              >
                <div
                  :style="
                    payload[children.grupoId][children.numero].status ==
                    'loading'
                      ? 'opacity: 0.5'
                      : ''
                  "
                  class="children"
                  v-if="!children.dependente || mostrarDependente(children)"
                >
                  <div
                    v-html="children.preambulo"
                    class="subtitulo mb-4"
                    v-if="children.preambulo"
                  ></div>
                  <span class="numeration">{{ children.numero }}</span> -
                  {{ children.texto }}
                  <app-modal-show-evidence
                    :evidence="children.evidencia"
                    :color="'primary'"
                    v-if="children.evidencia"
                    :title="'Clique para saber mais'"
                    :isHtml="true"
                    :titulo="'Informação Importante'"
                  >
                  </app-modal-show-evidence>

                  <div
                    v-html="children.subtitulo"
                    class="subtitulo"
                    v-if="children.subtitulo"
                  ></div>

                  <div class="filho">
                    <v-text-field
                      v-model="
                        payload[children.grupoId][children.numero].resposta
                      "
                      v-mask="['##:##-##:##']"
                      v-if="children.tipoResposta == tipoDiagnostico.intervalo"
                      placeholder="00:00-00:00"
                      :name="`resposta${children.grupoId}${children.numero}`"
                      :ref="`resposta${children.grupoId}${children.numero}`"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.numero]
                        )
                          ? [rulesMaxIntervalo, rulesObg]
                          : [rulesMaxIntervalo]
                      "
                      :disabled="isEnviada()"
                      :readOnly="
                        payload[children.grupoId][children.numero].status ==
                        'loading'
                      "
                      hide-details="auto"
                      @blur="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.numero}`,
                            i
                          );
                        }
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="
                        payload[children.grupoId][children.numero].resposta
                      "
                      v-if="children.tipoResposta == tipoDiagnostico.telefone"
                      :placeholder="'(00) 0000-0000'"
                      :name="`resposta${children.grupoId}${children.numero}`"
                      :ref="`resposta${children.grupoId}${children.numero}`"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.numero]
                        )
                          ? [rulesObg]
                          : [true]
                      "
                      :disabled="isEnviada()"
                      :readOnly="
                        payload[children.grupoId][children.numero].status ==
                        'loading'
                      "
                      hide-details="auto"
                      @blur="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.numero}`,
                            i
                          );
                        }
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="
                        payload[children.grupoId][children.numero].resposta
                      "
                      v-mask="['#####-###']"
                      v-if="children.tipoResposta == tipoDiagnostico.cep"
                      :placeholder="'00000-000'"
                      :name="`resposta${children.grupoId}${children.numero}`"
                      :ref="`resposta${children.grupoId}${children.numero}`"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.numero]
                        )
                          ? [rulesMaxCep, rulesObg]
                          : [true]
                      "
                      :disabled="isEnviada()"
                      :readOnly="
                        payload[children.grupoId][children.numero].status ==
                        'loading'
                      "
                      hide-details="auto"
                      @blur="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.numero}`,
                            i
                          );
                        }
                      "
                    ></v-text-field>
                    <v-textarea
                      v-model="
                        payload[children.grupoId][children.numero].resposta
                      "
                      v-if="children.tipoResposta == tipoDiagnostico.textArea"
                      placeholder="Escreva aqui"
                      :name="`resposta${children.grupoId}${children.numero}`"
                      :ref="`resposta${children.grupoId}${children.numero}`"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.numero]
                        )
                          ? rules
                          : [true]
                      "
                      hide-details="auto"
                      :disabled="isEnviada()"
                      :readOnly="
                        payload[children.grupoId][children.numero].status ==
                        'loading'
                      "
                      @blur="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.numero}`,
                            i
                          );
                        }
                      "
                    ></v-textarea>
                    <v-text-field
                      v-model="
                        payload[children.grupoId][children.numero].resposta
                      "
                      v-if="children.tipoResposta == tipoDiagnostico.numero"
                      placeholder="Escreva aqui"
                      :name="`resposta${children.grupoId}${children.numero}`"
                      :ref="`resposta${children.grupoId}${children.numero}`"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.numero]
                        )
                          ? rules
                          : [true]
                      "
                      type="number"
                      hide-details="auto"
                      :disabled="isEnviada()"
                      :readOnly="
                        payload[children.grupoId][children.numero].status ==
                        'loading'
                      "
                      @blur="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.numero}`,
                            i
                          );
                        }
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="
                        payload[children.grupoId][children.numero].resposta
                      "
                      v-if="children.tipoResposta == tipoDiagnostico.texto"
                      placeholder="Escreva aqui"
                      :name="`resposta${children.grupoId}${children.numero}`"
                      :ref="`resposta${children.grupoId}${children.numero}`"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.numero]
                        )
                          ? rules
                          : [true]
                      "
                      hide-details="auto"
                      :disabled="isEnviada()"
                      :readOnly="
                        payload[children.grupoId][children.numero].status ==
                        'loading'
                      "
                      @blur="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.numero}`,
                            i
                          );
                        }
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="
                        payload[children.grupoId][children.numero].resposta
                      "
                      v-if="children.tipoResposta == tipoDiagnostico.email"
                      placeholder="Escreva aqui"
                      :rules="emailRules"
                      hide-details="auto"
                      :name="`resposta${children.grupoId}${children.numero}`"
                      :ref="`resposta${children.grupoId}${children.numero}`"
                      :disabled="isEnviada()"
                      :readOnly="
                        payload[children.grupoId][children.numero].status ==
                        'loading'
                      "
                      @blur="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.numero}`,
                            i
                          );
                        }
                      "
                    ></v-text-field>
                    <v-radio-group
                      v-model="
                        payload[children.grupoId][children.numero].resposta
                      "
                      v-if="children.tipoResposta == tipoDiagnostico.boolean"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.numero]
                        )
                          ? rules
                          : [true]
                      "
                      hide-details="auto"
                      :name="`resposta${children.grupoId}${children.numero}`"
                      :ref="`resposta${children.grupoId}${children.numero}`"
                      :disabled="
                        payload[children.grupoId][children.numero].status ==
                          'loading' || isEnviada()
                      "
                      @change="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.numero}`,
                            i
                          );
                        }
                      "
                    >
                      <v-radio label="Sim" :key="1" :value="true"></v-radio>
                      <v-radio label="Não" :key="2" :value="false"></v-radio>
                    </v-radio-group>
                    <v-text-field
                      v-model="
                        payload[children.grupoId][children.numero].resposta
                      "
                      v-mascara="'##:##'"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.numero]
                        )
                          ? [rulesHoras, rulesObg]
                          : [rulesHoras]
                      "
                      v-if="children.tipoResposta == tipoDiagnostico.horaMin"
                      hide-details="auto"
                      placeholder="hh:mm"
                      :name="`resposta${children.grupoId}${children.numero}`"
                      :ref="`resposta${children.grupoId}${children.numero}`"
                      :disabled="isEnviada()"
                      :readOnly="
                        payload[children.grupoId][children.numero].status ==
                        'loading'
                      "
                      @blur="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.numero}`,
                            i
                          );
                        }
                      "
                    ></v-text-field>
                    <v-autocomplete
                      v-if="children.tipoResposta == tipoDiagnostico.lista115"
                      v-model="
                        payload[children.grupoId][children.numero].resposta
                      "
                      :ref="`resposta${children.grupoId}${children.numero}`"
                      :items="[
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                        '10',
                        '11',
                        '12',
                        '13',
                        '14',
                        '15',
                      ]"
                      placeholder="Selecione a quantidade"
                      :rules="
                        isRulesNeeded(
                          children,
                          payload[children.grupoId][children.numero]
                        )
                          ? rules
                          : [true]
                      "
                      @change="
                        () => {
                          save(
                            children,
                            grupo,
                            `resposta${children.grupoId}${children.numero}`,
                            i
                          );
                        }
                      "
                      :disabled="
                        payload[children.grupoId][children.numero].status ==
                          'loading' || isEnviada()
                      "
                      :clearable="true"
                    >
                      <template slot="no-data">
                        Nenhum Ator retornado
                      </template>
                    </v-autocomplete>
                    <div
                      style="width: 100%"
                      v-if="
                        children.tipoResposta == tipoDiagnostico.arquivo ||
                        children.tipoResposta == tipoDiagnostico.video
                      "
                    >
                      <v-file-input
                        :rules="[
                          children.obrigatorio &&
                          payload[children.grupoId][children.numero].files
                            .length != children.quantidadePermitida
                            ? rulesObg
                            : true,
                        ]"
                        :name="`resposta${children.grupoId}${children.numero}`"
                        :ref="`resposta${children.grupoId}${children.numero}`"
                        :accept="children.tipoExtensaoPermitida"
                        placeholder="Selecione o arquivo"
                        v-model="
                          payload[children.grupoId][children.numero].resposta
                        "
                        v-if="!isEnviada()"
                        :disabled="
                          payload[children.grupoId][children.numero].status ==
                            'loading' ||
                          payload[children.grupoId][children.numero].files
                            .length == children.quantidadePermitida ||
                          isEnviada()
                        "
                        :hint="`Quantidade de arquivos:
                    ${children.quantidadePermitida} `"
                        persistent-hint
                        @change="
                          () => {
                            save(
                              children,
                              grupo,
                              `resposta${children.grupoId}${children.numero}`,
                              i,
                              true
                            );
                          }
                        "
                      >
                      </v-file-input>

                      <div
                        v-if="
                          isEnviada() &&
                          payload[children.grupoId][children.numero].files
                            .length == 0
                        "
                        style="font-size: 14px; margin: 5px 26px; opacity: 0.5"
                      >
                        Nenhum arquvio enviado
                      </div>
                      <div
                        style="
                          display: flex;
                          row-gap: 20px;
                          flex-direction: column;
                          margin: 0 10px;
                          z-index: 1;
                          position: relative;
                          margin-top: 1rem;
                        "
                        v-if="
                          payload[children.grupoId][children.numero].files &&
                          payload[children.grupoId][children.numero].files
                            .length > 0
                        "
                      >
                        <div
                          style="color: #2d6189"
                          v-for="(file, index) in payload[children.grupoId][
                            children.numero
                          ].files"
                          :key="index"
                        >
                          <span
                            style="cursor: pointer"
                            @click="
                              downloadEvidencia(
                                file.evidenciaId,
                                children,
                                payload[children.grupoId][children.numero]
                              )
                            "
                            >{{ file.filename }}</span
                          >
                          <v-btn
                            outlined
                            color="error"
                            class="ml-3"
                            v-if="!isEnviada()"
                            @click="
                              deleteFile(
                                file.evidenciaId,
                                payload[children.grupoId][children.numero]
                              )
                            "
                          >
                            <v-icon>mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </div>
                    <div class="status">
                      <template>
                        <div
                          class="salvar"
                          v-if="
                            payload[children.grupoId][children.numero].status ==
                            'success'
                          "
                        >
                          <v-icon color="#0c6b10"
                            >mdi-checkbox-marked-circle</v-icon
                          >
                          Salvo
                        </div>

                        <div
                          class="salvarErro"
                          v-if="
                            payload[children.grupoId][children.numero].status ==
                            'error'
                          "
                        >
                          <v-icon color="#FF5252">mdi-block-helper</v-icon>
                          Não Salvo
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </template>
              <div
                v-if="
                  payload[children.grupoId][children.numero].status == 'loading'
                "
                style="position: absolute; left: 50%; top: 29%; z-index: 1"
              >
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </div>
            </div>
          </template>
        </template>
      </div>
      <div class="buttons">
        <v-btn color="laranja" @click="back()" style="color: #fff">
          {{ !isEnviada() ? "Salvar e sair" : "voltar" }}
        </v-btn>
        <v-btn
          color="azulclarosc"
          @click="enviarAnalise"
          v-if="!isEnviada()"
          style="color: #fff"
        >
          Finalizar diagnóstico
        </v-btn>
      </div>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import tipoDiagnosticoEnum from "../tipoDiagnostico";

import { cityAPI } from "@/modules/city";
import moment from "moment";

import { seloDiagnosticoPerguntasAPI } from "../API/seloDiagnosticoPerguntasAPI";
import { seloDiagnosticoRespostaAPI } from "../API/seloDiagnosticoRespostaAPI";
import { seloDiagnosticoEvidenciasAPI } from "../API/seloDiagnosticoEvidenciasAPI";

import AppModalShowEvidence from "@/modules/diagnostic/components/ModalShowEvidence";

import * as tus from "tus-js-client";
import Swal from "sweetalert2";

export default {
  components: {
    AppModalShowEvidence,
  },
  data() {
    return {
      payload: {},
      headers: [],
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      municipio: {},
      tiposCampoMapeados: {},
      closeGrupos: {},
      allRespostas: [],
      breadCrumbs: [
        {
          text: "Selecionar a Sala",
          disabled: false,
          to: "/",
          exact: true,
        },
        {
          text: "Preencher Diagnóstico",
          disabled: false,
          to: `/cidade/${this.$route.params.id}`,
          exact: true,
        },
        {
          text: "Diagnóstico",
          disabled: true,
          to: `/cidade/${this.$route.params.id}/diagnostic/selo`,
          exact: true,
        },
      ],
      municipioId: this.$route.params.id,
      rulesHoras: (v) => {
        if (!this.horaRegex.test(v)) {
          return "Hora inválida";
        }
        return true;
      },
      rulesMaxIntervalo: (v) => {
        // eslint-disable-next-line eqeqeq
        if (v && v.length != 11) {
          return "Intervalo inválido";
        }
        return true;
      },
      rulesMaxCep: (v) => {
        // eslint-disable-next-line eqeqeq
        if (v && v.length != 9) {
          return "CEP inválido";
        }
        return true;
      },
      rulesTelCep: (v) => {
        if (v && v.length < 13) {
          return "Telefone inválido";
        }
        return true;
      },
      rulesObg: (v) => {
        if (v === false) {
          return true;
        }
        // eslint-disable-next-line eqeqeq
        if (v == "" || !v) {
          return "Campo Obrigatório";
        }
        return true;
      },

      rulesFile: (files) => {
        if (files) {
          var somaTotal = 0;
          if (Array.isArray(files)) {
            somaTotal = files.reduce((a, b) => {
              return a + b.size;
            }, 0);
          } else {
            somaTotal = files.size;
          }

          return somaTotal > 7000000
            ? "Total de arquivos não pode ser maior que 5MB!"
            : true;
        }

        return !files;
      },
      rulesVideo: (files) => {
        if (files) {
          var somaTotal = 0;
          if (Array.isArray(files)) {
            somaTotal = files.reduce((a, b) => {
              return a + b.size;
            }, 0);
          } else {
            somaTotal = files.size;
          }

          return somaTotal > 30000000
            ? "Total de arquivos não pode ser maior que 30MB!"
            : true;
        }

        return !files;
      },
      horaRegex: /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/,
      emailREgex:
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      rules: [
        (v) => {
          if (v === false) {
            return true;
          }
          // eslint-disable-next-line eqeqeq
          if (v == "" || !v) {
            return "Campo Obrigatório";
          }
          return true;
        },
      ],
      emailRules: [
        (v) =>
          !v
            ? "Campo Obrigatório"
            : !this.emailREgex.test(v)
            ? "E-mail inválido"
            : true,
      ],
      user: JSON.parse(localStorage.getItem("user")),
      perguntas: [],
      tipoDiagnostico: tipoDiagnosticoEnum,
      allPerguntas: [],
      idPerguntaCoringa: 143,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    aparecerAbaixoPerguntaCoringa(perguntaId) {
      const pergunta = this.allPerguntas.filter(
        (p) => p.perguntaId == this.idPerguntaCoringa
      )[0];
      const resposta = this.payload[pergunta.grupoId][pergunta.perguntaId];

      if (resposta && resposta.resposta) {
        return true;
      }

      if (perguntaId > this.idPerguntaCoringa) {
        return false;
      } else {
        return true;
      }
    },

    statusPreGrupo(grupo, index) {
      const valoresGrupo = Object.values(this.payload[grupo.grupoId]);
      if (
        valoresGrupo.some((item) => {
          // eslint-disable-next-line eqeqeq
          return item.status == "error";
        })
      ) {
        this.perguntas[index].status = "error";
        this.$forceUpdate();
        return;
      }
      // eslint-disable-next-line eqeqeq
      if (valoresGrupo.some((item) => item.status == "success")) {
        this.perguntas[index].status = "inProgress";
        this.$forceUpdate();
        return;
      }

      this.perguntas[index].status = "";
      this.$forceUpdate();
    },
    mostrarDependente(children) {
      if (children.respostaDependente == 1) {
        return (
          this.payload[children.grupoId][children.dependente] &&
          this.payload[children.grupoId][children.dependente].resposta
        );
      }

      if (children.respostaDependente == 0)
        return (
          this.payload[children.grupoId][children.dependente] &&
          this.payload[children.grupoId][children.dependente].resposta === false
        );
    },
    statusGrupo(grupo, index) {
      const valoresGrupo = Object.values(this.payload[grupo.grupoId]);

      if (this.grupoCompleto(grupo)) {
        this.perguntas[index].status = "completed";
        this.$forceUpdate();
        return;
      }
      // eslint-disable-next-line eqeqeq
      if (valoresGrupo.some((item) => item.status == "success")) {
        this.perguntas[index].status = "inProgress";
        this.$forceUpdate();
        return;
      }

      this.perguntas[index].status = "";
      this.$forceUpdate();
    },
    mapRespostas() {
      seloDiagnosticoRespostaAPI
        .list(this.municipioId)
        .then((item) => {
          let resposta = item.data;
          this.allRespostas = item.data;

          let a =
            resposta.reduce(function (rv, x) {
              rv[x["perguntaGrupoId"]] = { ...rv[x["perguntaGrupoId"]] };
              if (!x.nomeArquivo) {
                rv[x["perguntaGrupoId"]][x["perguntaId"]] = x;
              } else {
                if (rv[x["perguntaGrupoId"]][x["perguntaId"]]) {
                  rv[x["perguntaGrupoId"]][x["perguntaId"]] = [
                    ...rv[x["perguntaGrupoId"]][x["perguntaId"]],
                    x,
                  ];
                } else rv[x["perguntaGrupoId"]][x["perguntaId"]] = [x];
              }

              return rv;
            }, {}) || {};

          this.payload = this.allPerguntas.reduce(function (rv, x) {
            if (
              x.tipoNome.toLowerCase().indexOf("arquivo") > -1 ||
              x.tipoNome.toLowerCase().indexOf("video") > -1
            ) {
              if (!rv[x["grupoId"]]) {
                rv[x["grupoId"]] = {};
              }
              if (!a[x["grupoId"]]) {
                a[x["grupoId"]] = {};
              }

              if (!a[x["grupoId"]][x["numero"]]) {
                rv[x["grupoId"]][x["numero"]] = { resposta: null, files: [] };
              } else {
                rv[x["grupoId"]][x["numero"]] = {
                  ...a[x["grupoId"]][x["numero"]][0],
                  resposta: null,
                  status: "success",
                  files: a[x["grupoId"]][x["numero"]].map((item) => ({
                    filename: item.nomeArquivo,
                    url: item.url,
                    evidenciaId: item.evidenciaId,
                  })),
                };
              }
            } else {
              if (!a[x["grupoId"]] && !rv[x["grupoId"]]) {
                a[x["grupoId"]] = { ...a[x["grupoId"]] };
                rv[x["grupoId"]] = { ...rv[x["grupoId"]] };
                rv[x["grupoId"]][x["numero"]] = { resposta: null };
              } else if (a[x["grupoId"]] && !rv[x["grupoId"]]) {
                if (
                  a[x["grupoId"]][x["numero"]] &&
                  a[x["grupoId"]][x["numero"]].resposta == "true"
                ) {
                  a[x["grupoId"]][x["numero"]].resposta = true;
                }
                // eslint-disable-next-line eqeqeq
                if (
                  a[x["grupoId"]][x["numero"]] &&
                  a[x["grupoId"]][x["numero"]].resposta == "false"
                ) {
                  a[x["grupoId"]][x["numero"]].resposta = false;
                }

                rv[x["grupoId"]] = {};
                rv[x["grupoId"]][x["numero"]] = (a[x["grupoId"]][
                  x["numero"]
                ] && {
                  ...a[x["grupoId"]][x["numero"]],
                  status: "success",
                }) || { resposta: null };
              } else if (!a[x["grupoId"]][x["numero"]]) {
                rv[x["grupoId"]][x["numero"]] = { resposta: null };
              } else {
                rv[x["grupoId"]] = { ...rv[x["grupoId"]] };
                // eslint-disable-next-line eqeqeq
                if (a[x["grupoId"]][x["numero"]].resposta == "true") {
                  a[x["grupoId"]][x["numero"]].resposta = true;
                }
                // eslint-disable-next-line eqeqeq
                if (a[x["grupoId"]][x["numero"]].resposta == "false") {
                  a[x["grupoId"]][x["numero"]].resposta = false;
                }

                rv[x["grupoId"]][x["numero"]] = {
                  ...a[x["grupoId"]][x["numero"]],
                  status: "success",
                };
              }
            }

            return rv;
          }, {});

          this.perguntas.forEach((val) => {
            if (this.grupoCompleto(val)) {
              val.status = "completed";
              val.close = true;
            }
          });

          this.$forceUpdate();
          this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao obter respostas");

          console.log("mapRespostas err: ", err);
          this.setLoading(false);
        });
    },
    getOptions(file) {
      return {
        endpoint:
          "https://api.cloudflare.com/client/v4/accounts/e2f8a6cba3853a64e90ed0683c02e9c8/stream",
        headers: {
          Authorization: "Bearer gUgZlz0PyIrgJA1SyZd6s-cVsLQv-3fMqu-6IQNU",
        },
        chunkSize: 50 * 1024 * 1024, // Required a minimum chunk size of 5MB, here we use 50MB.
        retryDelays: [0, 3000, 5000, 10000, 20000], // Indicates to tus-js-client the delays after which it will retry if the upload fails
        metadata: {
          filename: file.name,
          filetype: file.type,
        },
      };
    },
    save(children, grupo, nomeForm, index, isFile) {
      // eslint-disable-next-line eqeqeq
      if (this.payload[children.grupoId][children.numero].status == "loading") {
        return;
      }

      this.$forceUpdate();
      const refName = this.$refs[nomeForm][0];
      const valid = refName.validate();
      if (!valid) {
        this.payload[children.grupoId][children.numero].status = "error";
        this.statusPreGrupo(grupo, index);
        this.$forceUpdate();
        return;
      }

      const save = {
        municipioId: this.municipioId,
        usuarioId: this.user.usuarioId,
        perguntaId: children.numero,
        dataHora: moment().format("YYYY-MM-DD HH:mm:ss"),
        resposta: isFile
          ? ""
          : this.payload[children.grupoId][children.numero].resposta,
        respostaId: this.payload[children.grupoId][children.numero].respostaId,
        respondida: true,
        enviada: false,
        perguntaGrupoId: children.grupoId,
      };

      if (isFile) {
        this.setLoading(true);
        if (!this.payload[children.grupoId][children.numero].resposta) {
          this.setLoading(false);

          return;
        }
      }

      seloDiagnosticoRespostaAPI
        .atualizar(save)
        .then(async ({ data }) => {
          if (isFile) {
            var file = this.payload[children.grupoId][children.numero].resposta;
            if (
              Array.isArray(
                this.payload[children.grupoId][children.numero].resposta
              )
            ) {
              file =
                this.payload[children.grupoId][children.numero].resposta[0];
            }

            if (file.type.indexOf("video") > -1) {
              const minhaPromise = new Promise((resolve, reject) => {
                var upload = new tus.Upload(file, {
                  ...this.getOptions(file, children),
                  onError: function (error) {
                    console.log("error: ", error);
                    throw error;
                  },
                  // onProgress: function (bytesUploaded, bytesTotal) {
                  //   var percentage = (
                  //     (bytesUploaded / bytesTotal) *
                  //     100
                  //   ).toFixed(2)
                  // },
                  onSuccess: function () {
                    resolve(upload);
                  },
                });

                upload.start();
              });
              let formData = new FormData();

              const val = await minhaPromise;

              formData.append("usuarioId", save.usuarioId);
              formData.append("perguntaId", save.perguntaId);

              formData.append("municipioId", save.municipioId);
              formData.append("respostaId", data.respostaId);
              formData.append("url", val.url);
              formData.append("nomeArquivo", val.file.name);

              seloDiagnosticoEvidenciasAPI
                .add(formData)
                .then(() => {
                  this.filteredItems();
                })
                .catch((err) => {
                  console.log("err: ", err);
                  this.$notification.error(
                    "Erro ao salvar o arquivo da pergunta: ",
                    save.perguntaId
                  );
                  this.payload[children.grupoId][children.numero].status =
                    "error";
                  this.statusGrupo(grupo, index);
                  this.$forceUpdate();
                });
            } else {
              let formData = new FormData();

              if (
                Array.isArray(
                  this.payload[children.grupoId][children.numero].resposta
                )
              ) {
                for (
                  let i = 0;
                  i <
                  this.payload[children.grupoId][children.numero].resposta
                    .length;
                  i++
                ) {
                  formData.append(
                    "arquivo",
                    this.payload[children.grupoId][children.numero].resposta[i]
                  );
                }
              } else {
                formData.append(
                  "arquivo",
                  this.payload[children.grupoId][children.numero].resposta
                );
              }
              formData.append("usuarioId", save.usuarioId);
              formData.append("perguntaId", save.perguntaId);

              formData.append("municipioId", save.municipioId);
              formData.append("respostaId", data.respostaId);

              seloDiagnosticoEvidenciasAPI
                .add(formData)
                .then(() => {
                  this.filteredItems();
                })
                .catch((err) => {
                  console.log("err: ", err);
                  this.$notification.error(
                    "Erro ao salvar o arquivo da pergunta: ",
                    save.perguntaId
                  );
                  this.payload[children.grupoId][children.numero].status =
                    "error";
                  this.statusGrupo(grupo, index);
                  this.$forceUpdate();
                });
            }
          } else {
            this.payload[children.grupoId][children.numero].status = "success";
            this.statusGrupo(grupo, index);
            this.$forceUpdate();
          }
        })
        .catch((err) => {
          this.$notification.error("Erro ao salvar a pergunta");

          console.log("err: ", err);
          this.payload[children.grupoId][children.numero].status = "error";
          this.statusGrupo(grupo, index);
          this.$forceUpdate();
        });
    },
    downloadEvidencia(evidenciaId, pergunta, resposta) {
      // eslint-disable-next-line eqeqeq
      if (pergunta.tipoResposta == this.tipoDiagnostico.video) {
        let link = document.createElement("a");
        link.href = resposta.url;
        link.target = "_blank";
        link.click();
      } else {
        seloDiagnosticoEvidenciasAPI
          .download(evidenciaId)
          .then((resp) => {
            let blob = new Blob([resp.data], {
              type: resp.headers["content-type"],
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.target = "_blank";
            link.click();

            this.setLoading(false);
          })
          .catch((resp) => {
            console.log("resp: ", resp);
            this.setLoading(false);
            this.$notification.error("Erro ao obter anexo");
          });
      }
    },

    grupoCompleto(grupo) {
      const valoresGrupo = Object.values(this.payload[grupo.grupoId]);
      // eslint-disable-next-line eqeqeq
      return valoresGrupo.every((item) => {
        let pergunta = grupo.children.filter(
          (val) => val.perguntaId == item.perguntaId
        )[0];
        return item.status == "success";
      });
    },
    filteredItems() {
      this.setLoading(true);

      seloDiagnosticoPerguntasAPI
        .getPerguntas()
        .then((val) => {
          this.allPerguntas = val.data;
          let groupBy = val.data;

          let key = "grupoId";
          let aux = groupBy.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
          }, {});

          this.perguntas = Object.keys(aux).map((key) => {
            return {
              grupoId: key,
              name: aux[key] && aux[key][0].grupoNome,
              children: aux[key],
            };
          });
          this.municipioInfo();
        })
        .catch((err) => {
          this.$notification.error("Erro ao obter perguntas");

          console.log("filteredItems err: ", err);
          this.setLoading(false);
        });
    },
    deleteFile(evidenciaId, children) {
      this.payload[children.perguntaGrupoId][children.perguntaId].status =
        "loading";

      seloDiagnosticoEvidenciasAPI
        .delete(evidenciaId)
        .then(() => {
          if (children.files && children.files.length > 0) {
            children.files.forEach((file, index) => {
              // eslint-disable-next-line eqeqeq
              if (file.evidenciaId == evidenciaId) {
                children.files.splice(index, 1);
              }
            });
          }

          this.payload[children.perguntaGrupoId][children.perguntaId].files =
            children.files;
          // eslint-disable-next-line eqeqeq
          if (!children.files || children.files.length == 0) {
            seloDiagnosticoRespostaAPI
              .delete(
                this.payload[children.perguntaGrupoId][children.perguntaId]
                  .respostaId
              )
              .then(() => {
                this.filteredItems();
              })
              .catch((err) => {
                console.log(
                  "diagnosticoSelo/List deleteFile delete resposta ",
                  err
                );
                this.$notification.error("Erro ao excluir o arquivo");
              });
          } else {
            this.filteredItems();
          }
        })
        .catch((err) => {
          console.log("diagnosticoSelo/List deleteFile delete file", err);
          this.$notification.error("Erro ao excluir o arquivo");
        });
    },
    municipioInfo() {
      this.setLoading(true);
      cityAPI
        .get(this.municipioId)
        .then((municipio) => {
          this.municipio = municipio.data;
          this.mapRespostas();
        })
        .catch((err) => {
          console.log("daignosticoSelo/List municipioInfo ", err);
          this.$notification.error("Erro ao buscar municipio");
        });
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    isEnviada() {
      // eslint-disable-next-line eqeqeq
      if (this.allRespostas.length == 0) return false;
      if (this.allRespostas.every((item) => item.enviada)) return true;

      return false;
    },
    isRulesNeeded(pergunta, resposta) {
      if (pergunta.obrigatorio && !pergunta.dependente) return true;
      if (pergunta.dependente && pergunta.obrigatorio) {
        let dependente = this.payload[pergunta.grupoId][pergunta.dependente];
        if (dependente.resposta || dependente.resposta === false) return true;
        else return false;
      }

      return false;
    },
    async enviarAnalise() {
      var isValid = await this.check();

      if (!isValid) {
        const errorElement = document.querySelector(".error--text");
        errorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
        return;
      }
      Swal.fire({
        title: "Finalizar diagnóstico",
        text: `Ao finalizar os dados não poderão ser alterados. Deseja continuar?`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.enviarAnaliseFim();
        }
      });
    },
    enviarAnaliseFim() {
      this.setLoading(true);
      seloDiagnosticoRespostaAPI
        .enviarAnalise(this.municipioId)
        .then(() => {
          this.setLoading(false);
          this.filteredItems();
          this.$notification.success(
            "O seu diagnóstico foi finalizado com sucesso. Obrigado!"
          );
        })
        .catch((err) => {
          this.setLoading(false);

          this.$notification.error("Erro ao enviar para analise");
          console.log("diagnosticoselo/list enviarAnalise ", err);
        });
    },
    back() {
      if (!this.isEnviada()) {
        Swal.fire({
          title: "O seu diagnóstico foi salvo",
          text: `Lembramos que não foi enviado para análise`,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.isConfirmed) {
            this.$router.push("/cidade/" + this.municipioId);
          }
        });
      } else {
        this.$router.push("/cidade/" + this.municipioId);
      }
    },
  },

  beforeMount() {
    if (this.isParceiro) {
      this.idPerguntaCoringa = 115;

      this.breadCrumbs = [
        {
          text: "Selecionar o Parceiro",
          disabled: false,
          to: "/",
          exact: true,
        },
        {
          text: "Preencher Diagnóstico",
          disabled: false,
          to: `/cidade/${this.$route.params.id}`,
          exact: true,
        },
        {
          text: "Diagnóstico",
          disabled: true,
          to: `/cidade/${this.$route.params.id}/diagnostic/selo`,
          exact: true,
        },
      ];
    }
    this.filteredItems();
  },

  computed: {
    ...mapGetters(["isSala", "isFullAdmin", "isParceiro"]),
  },
};
</script>
<style lang="scss" scoped>
.subtitulo {
  font-size: 14px;
}
.buttons {
  display: flex;
  justify-content: flex-end;
  column-gap: 1rem;
  margin-top: 1rem;
}
.grupo {
  margin-bottom: 1rem;
}

.enviada {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  text-align: center;
  margin: 2rem;
  font-size: 20px;
  /* font-weight: bold; */
  background: #606060;
  border-radius: 19px;
  padding: 10px;
  color: #fff;
  margin: 2rem auto;
  display: flex;
  align-items: center;
  column-gap: 10px;
}

.salvar {
  color: #0c6b10;
  border-radius: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-left: auto;
  column-gap: 5px;
}

.status {
  border-radius: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-left: auto;
  column-gap: 5px;
}

.salvarErro {
  color: #ff5252;
}

.bloco {
  position: sticky;
  top: 140px;
  background: #2d6189;
  color: #fff;
  padding: 10px;
  z-index: 2;
  display: flex;
  column-gap: 10px;
  cursor: pointer;
}
.completed {
  background: #0c6b10;
}

.error {
  background: #ff5252;
}

.inProgress {
  background: #f57d30;
  color: #fff;
  text-shadow: 3px 3px 13px rgba(0, 0, 0, 0.38);
}

.children {
  border: 1px solid #c1bebe8c;
  position: relative;
  .filho {
    display: flex;
  }
}
.children {
  padding: 10px;

  .numeration {
    font-weight: bold;
    font-size: 14px;
  }
}
</style>
